import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import MenuContainer from '../../../containers/MenuContainer';
import LocaleContainer from '../../../containers/LocaleContainer';


const Header = () => (
  <header className="row">
    <div className="column">
      <div className="ui stackable grid">
        <div className="twelve wide computer only column">
          <h1 className="ui header">
            <FormattedMessage
              id="title"
              description="App long title"
            />
          </h1>
        </div>
        <div className="four wide right aligned language computer only column">
          <LocaleContainer />
        </div>
      </div>
      <MenuContainer />
    </div>
  </header>
);

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/layout/header/Header.js
 **/